(function () {
  'use strict';

  function init() {
    var trigger = document.getElementById('AnnouncementCurrencyBtn');
    var drawer = document.getElementById('CurrencyDrawer');
    if (!trigger || !drawer) return;

    var overlay = document.getElementById('CurrencyDrawerOverlay');
    var closeBtn = document.getElementById('CurrencyDrawerClose');
    var searchInput = document.getElementById('CurrencyDrawerSearch');
    var list = document.getElementById('CurrencyDrawerList');
    var countryInput = document.getElementById('CurrencyDrawerCountryInput');
    var form = document.getElementById('CurrencyDrawerForm');
    var rows = list ? Array.prototype.slice.call(list.querySelectorAll('.currency-drawer__row')) : [];

    function open() {
      drawer.classList.add('is-open');
      document.body.classList.add('currency-drawer-open');
      if (searchInput) {
        searchInput.value = '';
        filterRows('');
        setTimeout(function () { searchInput.focus(); }, 50);
      }
    }

    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('currency-drawer-open');
    }

    function filterRows(term) {
      term = term.trim().toLowerCase();
      rows.forEach(function (row) {
        var name = (row.getAttribute('data-country-name') || '').toLowerCase();
        var match = name.indexOf(term) !== -1;
        row.parentElement.style.display = match ? '' : 'none';
      });
    }

    trigger.addEventListener('click', open);
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        filterRows(searchInput.value);
      });
    }

    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        if (countryInput) countryInput.value = row.getAttribute('data-country-code');
        if (form) form.submit();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
